import React, { createContext, FC, useState } from 'react';
import { Detector, defaultPollingConfig } from 'react-detect-offline';

export const OnlineContext = createContext({
  isOnline: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setPollingEnabled: (v: boolean) => {},
  isPollingEnabled: false,
});

export const OnlineContextProvider: FC = ({ children }) => {
  const [isPollingEnabled, setPollingEnabled] = useState(false);
  const [isOnline, setIsOnline] = useState(true);

  return (
    <OnlineContext.Provider value={{ isOnline, isPollingEnabled, setPollingEnabled }}>
      {children}

      <Detector
        key={`is-polling-enabled-${isPollingEnabled}`}
        polling={{
          ...defaultPollingConfig,
          enabled: isPollingEnabled,
          interval: 10000,
          timeout: 10000,
        }}
        onChange={(newIsOnline) => setIsOnline(newIsOnline)}
        render={() => null}
      />
    </OnlineContext.Provider>
  );
};
